export default {
  // Navbar keys
  nav: {
    home: 'ACCUEIL',
    shop: 'BOUTIQUE',
    contact: 'CONTACT',
    cart: 'Panier',
  },
  navbar: {
    home: 'ACCUEIL',
    shop: 'BOUTIQUE',
    contact: 'CONTACT',
    cart: 'Panier',
  },
  // Hero
  hero_button: 'EXPLORER ROSA AMNESIA',
  hero: {
    title: "Explorer Rosa Amnesia",
    subtitle: "Livraison rapide en Tunisie • Paiement à la livraison",
    cta: "EXPLORER ROSA AMNESIA"
  },
  // Home flat keys
  home_promo_delivery: 'Livraison rapide en Tunisie',
  home_promo_payment: 'Paiement à la livraison',
  home_new_arrivals: 'NOUVEAUTÉS',
  home_new_arrivals_subtitle: 'Découvrez nos dernières créations',
  home_see_collection: 'VOIR TOUTE LA COLLECTION',
  home_universe_title: "MAISON VOYOU",
  home_universe_text1: "We came from the blocks,\nwhere the nights were long\nand the dreams were louder than the city.",
  home_universe_text2: "Every piece carries a memory.\nEvery color carries a story.",
  // Section Notre Histoire
  home_histoire_since: 'Depuis le début',
  home_histoire_title: 'Notre Histoire',
  home_histoire_subtitle: 'Nés dans les blocs,',
  home_histoire_subtitle_accent: 'rêveurs par nature.',
  home_histoire_p1: "Voyou Rêveur n'est pas une marque comme les autres. C'est une histoire qui commence dans les rues, entre les murs des cités, là où les rêves naissent plus grands que les horizons.",
  home_histoire_p2: "Chaque pièce est une lettre d'amour à ceux qui ont grandi avec peu mais qui ont toujours rêvé grand. Le rose, le grafiti, les silhouettes — tout porte un sens, une mémoire, une identité.",
  home_histoire_quote: '"We came from the blocks, where the nights were long and the dreams were louder than the city."',
  home_histoire_cta: 'DÉCOUVRIR LA COLLECTION',
  home_advantage_payment: 'PAIEMENT À LA LIVRAISON',
  home_advantage_payment_desc: 'Payez à la réception de votre commande',
  home_advantage_delivery: 'LIVRAISON RAPIDE',
  home_advantage_delivery_desc: 'Livraison dans toute la Tunisie en 48-72h',
  home_advantage_quality: 'QUALITÉ PREMIUM',
  home_advantage_quality_desc: 'Matériaux soigneusement sélectionnés',
  home_instagram_title: '#PTITVOYOU',
  home_instagram_subtitle: 'Rejoignez notre communauté',
  home_instagram_button: 'SUIVRE @PTITVOYOU',
  // Boutique flat keys
  boutique_loading: 'Chargement des produits...',
  boutique_title: 'BOUTIQUE',
  boutique_subtitle: 'Découvrez notre collection complète',
  boutique_filters: 'FILTRES',
  boutique_sizes: 'TAILLES',
  boutique_colors: 'COULEURS',
  boutique_price: 'PRIX',
  boutique_reset: 'Réinitialiser',
  boutique_products_count: '{{count}} produits',
  boutique_no_results: 'Aucun produit ne correspond à vos critères',
  // Nested keys
  home: {
    newArrivals: "NOUVEAUTÉS",
    newArrivalsSubtitle: "Découvrez nos dernières créations",
    seeCollection: "VOIR TOUTE LA COLLECTION",
    universeTitle: "L'UNIVERS P'TIT VOYOU",
    universeText1: "P'tit Voyou, c'est plus qu'une marque, c'est une attitude. Née de l'envie de créer des pièces uniques qui reflètent l'esprit rebelle et rêveur d'une génération qui refuse de se conformer.",
    universeText2: "Chaque création est pensée pour exprimer ta personnalité, ta liberté, ta façon de voir le monde. Parce que le style, ce n'est pas suivre les tendances, c'est créer les siennes.",
    paymentTitle: "PAIEMENT À LA LIVRAISON",
    paymentDesc: "Payez à la réception de votre commande",
    deliveryTitle: "LIVRAISON RAPIDE",
    deliveryDesc: "Livraison dans toute la Tunisie en 48-72h",
    qualityTitle: "QUALITÉ PREMIUM",
    qualityDesc: "Matériaux soigneusement sélectionnés",
    instagramTitle: "#PTITVOYOU",
    instagramSubtitle: "Rejoignez notre communauté",
    followButton: "SUIVRE @PTITVOYOU"
  },
  boutique: {
    title: "BOUTIQUE",
    subtitle: "Découvrez notre collection complète",
    filters: "FILTRES",
    sizes: "TAILLES",
    colors: "COULEURS",
    price: "PRIX",
    reset: "Réinitialiser",
    loading: "Chargement des produits...",
    productsCount: "{{count}} produits",
    noResults: "Aucun produit ne correspond à vos critères"
  },
  produit: {
    home: "Accueil",
    shop: "Boutique",
    size: "TAILLE",
    color: "COULEUR",
    quantity: "QUANTITÉ",
    addToCart: "AJOUTER AU PANIER",
    description: "DESCRIPTION",
    qualityBullet: "Matériaux de qualité premium",
    fitBullet: "Coupe régulière",
    designBullet: "Design unique",
    deliveryTitle: "LIVRAISON & RETOUR",
    deliveryText: "Livraison gratuite en Tunisie pour les commandes de plus de 150 TND. Retours gratuits sous 14 jours.",
    youMightLike: "VOUS AIMEREZ AUSSI",
    addedToCart: "Produit ajouté au panier"
  },
  panier: {
    title: "PANIER",
    emptyCart: "Votre panier est vide",
    emptyCartDesc: "Ajoutez des produits pour commencer",
    size: "Taille",
    color: "Couleur",
    remove: "Retirer",
    summary: "RÉSUMÉ",
    subtotal: "Sous-total",
    shipping: "Livraison",
    shippingFree: "Gratuite",
    total: "TOTAL",
    placeOrder: "PASSER LA COMMANDE",
    continueShopping: "Continuer mes achats",
    securePayment: "Paiement sécurisé",
    fastDelivery: "Livraison rapide",
    freeReturns: "Retours gratuits"
  },
  commande: {
    title: "FINALISER VOTRE COMMANDE",
    shippingInfo: "INFORMATIONS DE LIVRAISON",
    firstName: "PRÉNOM",
    lastName: "NOM",
    phone: "TÉLÉPHONE",
    address: "ADRESSE",
    city: "VILLE",
    notes: "NOTES DE COMMANDE (OPTIONNEL)",
    paymentMethod: "MODE DE PAIEMENT",
    paymentOnDelivery: "Paiement à la livraison",
    paymentOnDeliveryDesc: "Payez en espèces à la réception de votre commande",
    confirmOrder: "CONFIRMER LA COMMANDE",
    yourOrder: "VOTRE COMMANDE",
    subtotal: "Sous-total",
    shipping: "Livraison",
    shippingFree: "Gratuite",
    total: "TOTAL"
  },
  confirmation: {
    title: "COMMANDE CONFIRMÉE",
    thankYou: "Merci pour votre commande !",
    orderNumber: "Numéro de commande",
    phoneConfirm: "Confirmation téléphonique",
    phoneConfirmDesc: "Nous vous appellerons pour confirmer votre commande",
    fastDelivery: "Livraison rapide",
    fastDeliveryDesc: "Livraison en 48-72h dans toute la Tunisie",
    paymentOnDelivery: "Paiement à la livraison",
    paymentOnDeliveryDesc: "Payez en espèces à la réception",
    continueShopping: "CONTINUER MES ACHATS",
    backToHome: "RETOUR À L'ACCUEIL"
  },
  contact: {
    title: "CONTACTEZ-NOUS",
    subtitle: "Nous sommes là pour répondre à toutes vos questions",
    fullName: "NOM COMPLET",
    email: "EMAIL",
    phone: "TÉLÉPHONE",
    message: "MESSAGE",
    send: "ENVOYER",
    successMessage: "Message envoyé avec succès !",
    information: "INFORMATIONS",
    phoneLabel: "TÉLÉPHONE",
    emailLabel: "EMAIL",
    hours: "HORAIRES",
    hoursText: "Lun-Sam : 9h-18h\nDimanche : Fermé",
    followUs: "SUIVEZ-NOUS",
    communityText: "Rejoignez notre communauté et restez informé de nos dernières actualités"
  },
  footer: {
    navigation: "NAVIGATION",
    home: "Accueil",
    shop: "Boutique",
    contact: "Contact",
    information: "INFORMATIONS",
    delivery: "Livraison & Retours",
    terms: "Conditions Générales",
    privacy: "Politique de Confidentialité",
    followUs: "SUIVEZ-NOUS",
    brandText: "North Africain Reveur",
    rights: "Tous droits réservés"
  }
};
